<template>
  <bim-select
    width="100%"
    :value="value"
    @input="v => $emit('input', v)"
    :placeholder="placeholder"
    :options="options"
    formKey="value"
    :formModel="_self"
    @blur="validate"
    :disabled="disabled"
    :showReset="showReset"
  />
</template>

<script>
import validationMixin from '../validation.mixin'
import bimSelect from '@/components/form/bimSelect/bimSelect'
export default {
  name: 'FieldSelect',
  mixins: [validationMixin],
  props: {
    placeholder: String,
    options: Array,
    value: [String, Number],
    disabled: Boolean,
    showReset: Boolean
  },
  components: {
    bimSelect,
  }
}
</script>

<style scoped lang="scss">

</style>
